import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { PreviewDetailComponent } from '../../../quote-order-sample-core/preview-detail/preview-detail.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from '../../constants';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-product-consumables-summary',
  // Eager: Angular 22 defaults every component to OnPush, which would leave this view
  // unpainted after its subscribe callbacks (see app.component.ts for the full note).
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
  imports: [DecimalPipe, CurrencyPipe],
  templateUrl: './product-consumables-summary.component.html',
  styleUrl: './product-consumables-summary.component.css'
})
export class ProductConsumablesSummaryComponent {
  @Input() consumableSummaryQuoteOrder: any
  @Input() isDisplayCalculatedConsumablesSummary: any
  @Input() isOrderCancel: any;
  @Input() isPreview: any;
  constants = Constants;
  @Input() isQuote: any
  isCollapsed: boolean = false;

  constructor(private modalService1: NgbModal,) { }

  /**
   * The table's data source depends on context (this same component renders both the on-page
   * summary and the "View Calculation" popup — see preview-detail.component.html):
   *  - On the page / full preview: the ACTUAL applied consumables (`quoteOverallSealerUnit`),
   *    which is all zeros when nothing has been applied.
   *  - In the "View Calculation" popup only: the not-yet-applied POTENTIAL need
   *    (`orderNotAppliedConsumableCalculators`), i.e. what the order would require.
   * The popup is the only context that is BOTH a preview and the calculated-summary view, so
   * we gate on both flags. (Quote detail passes isDisplayCalculatedConsumablesSummary=true but
   * not isPreview, so it keeps showing the applied summary — no regression.)
   * We intentionally read the source here rather than overwriting `quoteOverallSealerUnit`,
   * which previously made the page table mirror the popup once the backend returned real
   * potential figures instead of zeros.
   */
  get summaryData(): any {
    const showPotential = !!this.isPreview && !!this.isDisplayCalculatedConsumablesSummary;
    return showPotential
      ? this.consumableSummaryQuoteOrder?.orderNotAppliedConsumableCalculators
      : this.consumableSummaryQuoteOrder?.quoteOverallSealerUnit;
  }


  openConsumableCalculationPopUp(id: any) {
    const instance = this.modalService1.open(PreviewDetailComponent, {
      centered: false,
      windowClass:
        'donationModals quotes-model quote-order-preview quote-order-preview-consumables-summary',
      backdrop: 'static',
    });
    instance.componentInstance.isDisplayCalculatedConsumablesSummary = true;
    instance.componentInstance.isDisplayExpandableContent = false;
    instance.componentInstance.typeForDownload = Constants.DOWNLOAD_CONSUMABLES;
    instance.componentInstance.modelOrderDetail = this.consumableSummaryQuoteOrder;
    instance.closed.subscribe((result) => {
      if (result) {
      }
    });
  }

}
